export const BaseErrorCodes = {
  Core: 'CORE_ERROR',
  Validation: 'VALIDATION_ERROR',
  NotFound: 'NOT_FOUND',
} as const;

export type BaseErrorCode = (typeof BaseErrorCodes)[keyof typeof BaseErrorCodes];

export const DetailCodes = {
  SessionNotFound: 'SESSION_NOT_FOUND',
  SessionNotEligible: 'SESSION_NOT_ELIGIBLE',
  PathNotFound: 'PATH_NOT_FOUND',
  ProgressNotInitialized: 'PROGRESS_NOT_INITIALIZED',
  InvalidPhaseId: 'INVALID_PHASE_ID',
  UnknownPracticeScope: 'UNKNOWN_PRACTICE_SCOPE',
  InvalidInstrumentType: 'INVALID_INSTRUMENT_TYPE',
  PathNotActive: 'PATH_NOT_ACTIVE',
  FailedResolvePathAfterConflict: 'FAILED_RESOLVE_PATH_AFTER_CONFLICT',
  InvalidBootstrapId: 'INVALID_BOOTSTRAP_ID',
  UnsupportedInstrumentTuning: 'UNSUPPORTED_INSTRUMENT_TUNING',
  InvalidConfig: 'INVALID_CONFIG',
} as const;

export type DetailCode = (typeof DetailCodes)[keyof typeof DetailCodes];

export function isDetailCode(x: unknown): x is DetailCode {
  if (typeof x !== 'string') return false;
  for (const v of Object.values(DetailCodes)) {
    if (v === x) return true;
  }
  return false;
}
